import React, { useRef } from 'react';

import { HStack, Input, SpinnerButton, VStack } from "~/native-ui";
import { connect } from '~/redux/connect'
import { requestResetPasswordLink } from "~/rx/password";

export const ForgotPasswordForm = connect(null, {requestResetPasswordLink})(({labels,trans, requestResetPasswordLink}) => {
    const isSubmitting = false;
    const formValuesRef = useRef({});
    
    const onSubmit = async (e) => {
        e.preventDefault();
        requestResetPasswordLink(formValuesRef.current);
    };

    return (
        <form onSubmit={onSubmit}>
            <VStack space={4}>
                <Input disabled={isSubmitting} onSubmitEditing={onSubmit} type="text" onChange={
                    (value) => {formValuesRef.current.username = value }
                } placeholder={labels.username} />
                <HStack>
                    <SpinnerButton
                        disabled={isSubmitting}
                        icon={isSubmitting ? 'spinning' : ''}
                        onClick={onSubmit}
                        label={labels.submitButton}
                        type="submit"
                        variant="solid"
                        paddingLeft="4"
                        paddingRight="4"
                        _stack={{ space: "2" }}
                        primary
                        raised
                    />
                </HStack>
            </VStack>
        </form>
    )
});